import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { formatSectorsTrackNumbers } from '../adapters/monitor-information.adapter';
import { API_ATTEND_TRACK_URL } from '@/utils';
import { ISector } from '../types/Monitor';

const monitorInformationService = createApi({
  reducerPath: 'monitorInformationService',
  baseQuery: fetchBaseQuery({
    baseUrl: `${API_ATTEND_TRACK_URL}/totem-sector/monitor-information`,
  }),
  tagTypes: ['MonitorInformation'],
  endpoints: (builder) => ({
    getMonitorInformation: builder.query<ISector[], number>({
      query: (limit) => ({
        url: '',
        params: {
          limit,
        },
      }),
      transformResponse: (sectors: ISector[]): ISector[] =>
        formatSectorsTrackNumbers(sectors),
      providesTags: ['MonitorInformation'],
    }),
  }),
});

export default monitorInformationService;
export const { useGetMonitorInformationQuery } = monitorInformationService;
